import { createCSSVariable, getVariableValue } from "../createVariable";
const registerCSSVariable = (v) => {
  tokensValueToVariable.set(getVariableValue(v), v);
};
const variableToCSS = (v, unitless = false) => {
  return `--${createCSSVariable(v.name, false)}:${!unitless && typeof v.val === "number" ? `${v.val}px` : v.val}`;
};
const tokensValueToVariable = /* @__PURE__ */ new Map();
export {
  registerCSSVariable,
  tokensValueToVariable,
  variableToCSS
};
//# sourceMappingURL=registerCSSVariable.js.map
